import { IRIS_PAGE_LOAD_SUCCESS } from '../actionTypes/IrisActionTypes';

function TaxonomyReducer(state = [], action) {
    switch (action.type) {
        case IRIS_PAGE_LOAD_SUCCESS:
            return action.irisData && action.irisData.taxonomyData;
        default:
            return state;
    }
}

TaxonomyReducer.reducerName = 'taxonomyData';

export default TaxonomyReducer;
